/// <reference path="../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox.Nobox {
    import fld = AccountRow.Fields;

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.filterable()
    export class AccountGrid extends NoboxEntityGrid<AccountRow, any> {
        protected getColumnsKey() { return AccountColumns.columnsKey; }
        protected getDialogType() { return AccountDialog; }
        protected getIdProperty() { return AccountRow.idProperty; }
        protected getInsertPermission() { return AccountRow.insertPermission; }
        protected getLocalTextPrefix() { return AccountRow.localTextPrefix; }
        protected getService() { return AccountService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            var q = Q.parseQueryString();
            if (q["category"]) {
                var categoryCt = this.findQuickFilter(AccountCategoryEditor,
                    AccountRow.Fields.Category)
                categoryCt.set_value(q["category"]);
            }
            if (q["sd"] && q["ed"]) {
                var categoryDt = this.findQuickFilter(CustomDateFilter,
                    AccountRow.Fields.In);
                if (q["sd"] == "All" || q["ed"] == "All") {
                    categoryDt.set_value(null);
                    categoryDt.end_set_value(null);
                } else {
                    categoryDt.set_value(q["sd"]);
                    categoryDt.end_set_value(q["ed"]);
                }
            }
        }

        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();
            let Users = Q.getLookup("Nobox.UsersLookup").itemById as unknown as Administration.UserRow[];

            Q.first(columns, x => x.field == AccountRow.Fields.Category).format =
                ctx => `<a href="javascript:;" class="categories-link">${Q.htmlEncode(ctx.value)}</a>`;

            Q.first(columns, x => x.field == AccountRow.Fields.ChannelNm).format =
                ctx => {
                    return `<a href="javascript:;" class="channel-link" title="${ctx.value}">${ctx.value}</a>`;
                };
            Q.first(columns, x => x.field == AccountRow.Fields.BotActive).format =
                ctx => {
                    if (ctx.value == true) {
                        return `<span class="check-box-bot check-box no-float readonly  checked"></span>`;
                    } else {
                        return `<span class="check-box-bot check-box no-float readonly "></span>`;
                    }
                };
            Q.first(columns, x => x.field == fld.Users).format =
                ctx => {
                    let idList = ctx.value;
                    if (!idList)
                        return "";

                    idList = idList.split(",") as number[]
                    var elList = "";
                    var idLast = 0;
                    idList.forEach(function (x) {
                        let g = Users[BigInt(x)] as any;
                        idLast = x;
                        if (!g) {
                            elList += `<span id="${x.toString()}" class="users-link">${x.toString()}, </span>`;
                        } else {
                            elList += `<span id="${x.toString()}" class="users-link">${Q.htmlEncode(g.DisplayName)}, </span>`;
                        }
                    });
                    if (Users[BigInt(idLast)]) {
                        return `<a href="javascript:;">${elList.replace(Users[BigInt(idLast)].DisplayName + ", ", Users[BigInt(idLast)].DisplayName)}</a>`;
                    } else {
                        return `<a href="javascript:;">${elList.replace(idLast.toString() + ", ", idLast.toString())} </a>`;
                    }
                };
            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);
            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented()) {
                return;
            }

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            if (target.hasClass("channel-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by channel");
                var channelFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    AccountRow.Fields.Channel);
                channelFilter.set_value(`${item.Channel}`);
                this.refresh();
            } else if (target.hasClass("categories-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by category");
                var categoryFilter = this.findQuickFilter(AccountCategoryEditor,
                    AccountRow.Fields.Category);
                categoryFilter.set_value(`${item.Category}`);
                this.refresh();
            }else if (target.hasClass("users-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by Users");
                var usersFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    AccountRow.Fields.Users);
                usersFilter.set_value(usersFilter.get_value() + "," + target.attr("id"));
                this.refresh();
            } else if (target.hasClass("check-box-bot")) {
                e.preventDefault();

                if (item.BotActive == 1) {
                    //Q.confirm("Non Active Bot?", () => {
                    //    AccountService.Update({
                    //        EntityId: item.Id,
                    //        Entity: {
                    //            BotActive:0
                    //        }
                    //    }, (res) => {
                    //        this.refresh();
                    //    });
                    //});

                    AccountService.Update({
                        EntityId: item.Id,
                        Entity: {
                            BotActive: 0
                        }
                    }, (res) => {
                        this.refresh();
                    });
                } else {
                    //Q.confirm("Active Bot?", () => {
                    //    AccountService.Update({
                    //        EntityId: item.Id,
                    //        Entity: {
                    //            BotActive: 1
                    //        }
                    //    }, (res) => {
                    //        this.refresh();
                    //    });
                    //});
                    AccountService.Update({
                        EntityId: item.Id,
                        Entity: {
                            BotActive: 1
                        }
                    }, (res) => {
                        this.refresh();
                    });
                }
                
            }
        }
        protected getButtons() {
            var buttons = super.getButtons();
            var $this = this;
            if (!($(document).width() < 576)) {
                buttons.push({
                    icon: "fa-circle text-success",
                    title: "On Bots",
                    separator: true,
                    cssClass: "btn-on-bot",
                    hint: "Turn on all chatbot",
                    onClick: (e) => {
                        AccountService.OnAllBot({
                            EntityId: 0,
                            Entity: {
                                BotActive: 0
                            }
                        }, (res) => {
                            this.refresh();
                        });
                    }
                });

                buttons.push({
                    icon: "fa-circle text-black",
                    title: "Off Bots",
                    cssClass: "btn-off-bot",
                    hint: "Off all chatbot",
                    onClick: (e) => {
                        AccountService.OffAllBot({
                            EntityId: 0,
                            Entity: {
                                BotActive: 0
                            }
                        }, (res) => {
                            this.refresh();
                        });
                    }
                });
            } else {
                buttons.push({
                    icon: "fa-circle text-success",
                    title: "On",
                    separator: true,
                    cssClass: "btn-on-bot",
                    hint: "Turn on all chatbot",
                    onClick: (e) => {
                        AccountService.OnAllBot({
                            EntityId: 0,
                            Entity: {
                                BotActive: 0
                            }
                        }, (res) => {
                            this.refresh();
                        });
                    }
                });

                buttons.push({
                    icon: "fa-circle text-black",
                    title: "Off",
                    cssClass: "btn-off-bot",
                    hint: "Off all chatbot",
                    onClick: (e) => {
                        AccountService.OffAllBot({
                            EntityId: 0,
                            Entity: {
                                BotActive: 0
                            }
                        }, (res) => {
                            this.refresh();
                        });
                    }
                });
            }
            return buttons;
        }
        protected getQuickFilters() {
            var flt = super.getQuickFilters();
            //this.refresh();
            var filter1 = Q.first(flt, x => x.field == fld.Users);
            filter1.handler = h => {
                const request = (h.request as AccountListRequest);
                const values = (h.widget as Serenity.LookupEditor).values;
                if (h.active) {
                    request.UserIds = values.map(x => Number(x));
                    h.handled = true;
                } else {
                    request.UserIds = [];
                    h.handled = true;
                }
            };

            var filter2 = Q.first(flt, x => x.field == fld.In);
            filter2.handler = h => {
                const request = (h.request as Serenity.ListRequest);
                const start = (h.widget as CustomDateFilter).get_value();
                const end = (h.widget as CustomDateFilter).end_get_value();
                if (h.active) {
                    if (start != null && end != null) {
                        request.Criteria = [[["In"], ">=", start], "and", [["In"], "<=", end]]
                    } else if (start != null) {
                        request.Criteria = [["In"], ">=", start];
                    } else if (end != null) {
                        request.Criteria = [["In"], "<=", end];
                    }
                    h.handled = true;
                } else {
                    h.handled = true;
                }
            };

            return flt;
        }
    }
}